import { render, staticRenderFns } from "./AdditionalTerms.vue?vue&type=template&id=e8228c8c&scoped=true&"
import script from "./AdditionalTerms.vue?vue&type=script&lang=js&"
export * from "./AdditionalTerms.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalTerms.vue?vue&type=style&index=0&id=e8228c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8228c8c",
  null
  
)

export default component.exports